var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotifition2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08555 1H8.91412M5.71412 17H10.2855M7.99983 3.28571C3.87898 3.28571 3.47281 5.51453 3.43278 5.95389C3.42821 6.00404 3.42424 6.05354 3.41596 6.10321L2.54638 11.3207C2.52511 11.4483 2.47702 11.5699 2.40527 11.6776L1.63317 12.8357C1.22811 13.4433 1.66367 14.2571 2.39391 14.2571H13.6058C14.336 14.2571 14.7716 13.4433 14.3665 12.8357L13.5944 11.6776C13.5226 11.5699 13.4746 11.4483 13.4533 11.3207L12.5837 6.10321C12.5754 6.05354 12.5715 6.00404 12.5669 5.95389C12.5269 5.51453 12.1207 3.28571 7.99983 3.28571Z",
    stroke: "#363A44",
    strokeWidth: 1.82857,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotifition2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notifition2.307128ac41776250eff1322032057e84.svg";